import { ViewInvoiceDetail as ViewInvoiceDetailAtom } from 'atoms';
import Button from 'common/Button';
import ButtonSecondary from 'common/ButtonSecondary';
import InvoicePopup from 'pages/Payment/Invoice/InvoicePopup';
import { useRecoilState } from 'recoil';

import React, { useEffect, useState } from 'react';

const CreateInvoice = ({ getInvoices, isPopupOpen = false, setIsOpenPopup, providers = [], servicesList = [], providerFullDetails = [] }) => {
    const [openPopup, setOpenPopup] = useState(false);
    const [isManualMode, setIsManualMode] = useState(false);
    const [invoiceDetail, setInvoiceDetail] = useRecoilState(ViewInvoiceDetailAtom);

    const handleOpenPopup = () => {
        setIsManualMode(false);
        setOpenPopup(true);
    };

    const handleOpenManualPayment = () => {
        setIsManualMode(true);
        setOpenPopup(true);
    };

    const handleClosePopup = () => {
        setOpenPopup(false);
        setIsManualMode(false);
        setInvoiceDetail(null);
        if (setIsOpenPopup) {
            setIsOpenPopup(false);
        }
    };

    useEffect(() => {
        setOpenPopup(isPopupOpen);
    }, [isPopupOpen]);

    return (
        <div className={'flex flex-wrap gap-2 sm:gap-3'}>
            {!setIsOpenPopup && (
                <>
                    <ButtonSecondary className="flex-1 sm:flex-none min-w-0" onClick={handleOpenManualPayment}>
                        Manual Payment
                    </ButtonSecondary>
                    <Button className="flex-1 sm:flex-none min-w-0" onClick={handleOpenPopup}>
                        Create Invoice
                    </Button>
                </>
            )}
            <InvoicePopup open={openPopup} onClose={handleClosePopup} getInvoices={getInvoices} manualMode={isManualMode} providers={providers} servicesList={servicesList} providerFullDetails={providerFullDetails} />
        </div>
    );
};

export default CreateInvoice;

//this is a test comment